var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailTimeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 3.33301H3.33341C2.41675 3.33301 1.67508 4.08301 1.67508 4.99967L1.66675 14.9997C1.66675 15.9163 2.41675 16.6663 3.33341 16.6663H16.6667C17.5834 16.6663 18.3334 15.9163 18.3334 14.9997V4.99967C18.3334 4.08301 17.5834 3.33301 16.6667 3.33301ZM16.6667 14.9997H3.33341V6.66634L10.0001 10.833L16.6667 6.66634V14.9997ZM10.0001 9.16634L3.33341 4.99967H16.6667L10.0001 9.16634Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "active-stroke",
    clipRule: "evenodd",
    d: "M19.1304 13.5657C19.1304 15.5344 17.5344 17.1304 15.5647 17.1304C13.596 17.1304 12 15.5344 12 13.5657C12 11.5969 13.596 10 15.5647 10C17.5344 10 19.1304 11.5969 19.1304 13.5657Z",
    fill: "white",
    stroke: "#646464",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6721 14.4915L15.5449 13.8178V12.3691",
    stroke: "#646464",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "active-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailTimeLine);
export default __webpack_public_path__ + "static/media/MailTimeLine.b8ad8e95784de46d8bc91e7f6d858006.svg";
export { ForwardRef as ReactComponent };